@if (viewState(); as viewState) {
  @if (viewState.status === 'loading') {
    <div class="loading">Loading...</div>
  } @else if (viewState.status === 'error') {
    <div class="error">{{ viewState.error }}</div>
  } @else {
    <router-outlet />
  }
}
@for (sidePanel of sidePanels(); track sidePanel.id) {
  <app-side-panel-wrapper [sidePanel]="sidePanel" />
}
